import { AppBar, Theme, Toolbar } from '@mui/material';
import { Component, ReactNode, ReactNodeArray } from 'react';
import { ThemeExtension } from '@synergy/theme';
import { WithStyles, createStyles, withStyles } from '@mui/styles';

const styles = (theme: Theme) =>
    createStyles({
        appBar: {
            marginBottom: 0,
            boxShadow: 'none',
        },
        mainToolbar: {
            backgroundColor: theme.toolbar.backgroundColor,
            padding: 0,
            height: ThemeExtension.toolbar.height,
            minHeight: ThemeExtension.toolbar.height,
            maxHeight: ThemeExtension.toolbar.height,
            fontSize: 13,
            fontFamily: theme.typography.fontFamily,
        },
        container: {
            height: '100%',
            display: 'flex',

            '& button': {
                borderColor: theme.palette.common.white,
                borderStyle: 'solid',
            },
        },
        containerLeft: {
            marginRight: 'auto',

            '& button': {
                borderRightWidth: '1px',
            },
        },
        containerRight: {
            marginLeft: 'auto',

            '& button': {
                borderLeftWidth: '1px',
            },
        },
    });

interface PoolPageToolbarProps extends WithStyles<typeof styles> {
    mainToolbarLeftChildren?: ReactNode | ReactNodeArray;
    mainToolbarRightChildren?: ReactNode | ReactNodeArray;
}

export const PoolPageToolbar = withStyles(styles)(
    class PoolPagePageToolbarBase extends Component<PoolPageToolbarProps> {
        public override render() {
            return (
                <AppBar className={this.props.classes.appBar} position="sticky" color="default">
                    <Toolbar className={this.props.classes.mainToolbar}>
                        <div className={`${this.props.classes.container} ${this.props.classes.containerLeft}`}>
                            {this.props.mainToolbarLeftChildren}
                        </div>
                        <div className={`${this.props.classes.container} ${this.props.classes.containerRight}`}>
                            {this.props.mainToolbarRightChildren}
                        </div>
                    </Toolbar>
                </AppBar>
            );
        }
    }
);
